<template>
    <div class="p-3">
        <form-modal
            :id="componente"
            placeholder-button="Inserir" 

            :title-modal="titulo"

            :fields="colunasAcoes"
            :values="dados"

            ref="modalForm"

            :ok-cancel="!controlesLiberados"
            :somente-ok="!controlesLiberados"

            :create="controlesLiberados && permissao.c"
            :read="permissao.r"
            :update="permissao.u"
            :remove="controlesLiberados && permissao.d"

            @ok="ok"
            @edit="editar"
            @remove="deletar"
        >
            <template #modal>                
                <component :is="componente" :projeto-id="projeto.id" ref="modal" @salvar="salvar" @downloadArquivo="downloadArquivo" />
            </template>
        </form-modal>
    </div>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import cloneDeep from "lodash/cloneDeep";
import ProjetoGestaoService from "@/common/services/projeto_gestao/projeto_gestao.service";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";

import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "@/common/utils/helpers";

import colunas from "./colunas";

export default {
    mixins: [AlertasMixin],
    components: {
        FormModal,
        
        'producao-cientifica': () => import('./producao_cientifica.vue'),
        'capacitacao-profissional': () => import('./capacitacao_profissional.vue'),
        
    },
    props: {
        projeto: {
            required: true
        },
        componente : {
            type: String,
            default: ''
        },
        chavePermissao: {
            type: String,
            default: ''
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data: () => ({
        dados : [],
        colunas : [],
        titulo : ""
    }),
    mounted(){
        this.buscar();
        this.colunas = colunas[this.componente].colunas;
        this.titulo = colunas[this.componente].titulo;
    },
    methods : {
        ok : function(){
            this.$refs.modal.salvar();
        },
        salvar : function(e){
            let form = cloneDeep(e);
            if(!this.$refs.modal.validateState())
                return;

            this.confirmar('Aviso','Deseja salvar?').then(confirmado => {
                if(confirmado){

                    // Inseri o id do projeto
                    form.projetoGestaoId = this.projeto.id;

                    if(form.nomeArquivoAWSUP != null){
                        form.nomeArquivoAWS = form.nomeArquivoAWSUP;
                        delete form['nomeArquivoAWSUP'];
                    }

                    this.$store.dispatch(START_LOADING);
                    ProjetoGestaoService.salvarResultados(this.componente,form).then(() => {
                        this.alertaSucesso('Salvo com sucesso!').then(() => {
                            this.$refs.modalForm.closeModal();
                            this.buscar();
                        });
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao salvar");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            })
        },

        deletar : function(item){
            this.confirmar('Aviso','Deseja realmente excluir?').then(confirmado => {
                if(confirmado){

                    this.$store.dispatch(START_LOADING);
                    ProjetoGestaoService.deletarResultados(this.componente,item.id).then(() => {
                        this.alertaSucesso('Excluido com sucesso!');
                        this.buscar();
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao excluir");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            })
        },

        editar : function(item){
            let form = cloneDeep(item);
            this.$refs.modalForm.openModal().then(() => {
                this.$refs.modal.editar(form);
            });
        },

        buscar : function(){
            this.$store.dispatch(START_LOADING);
            ProjetoGestaoService.listarResultados(this.componente,this.ehTelaCooperada ? this.projeto.id : this.projeto.projetoGestaoId).then(response => {
                this.dados = response.data.data.itens;
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },

        downloadArquivo : function(id){
            this.$store.dispatch(START_LOADING);
            
            ProjetoGestaoService.downloadArquivoResultados(this.componente, id)
            .then(response => {
                helpers.baixarArquivo(response.data, response.headers);
                this.alertaSucesso("Download do Arquivo Concluido!");               
            }).catch(err => {
                console.log(err);
                this.alertaErro("Erro ao fazer Download do Arquivo");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
    },
    computed : {
        colunasAcoes : function(){
            let colunas = cloneDeep(this.colunas);
            colunas.push({ key: "actions", label: "Ações", });
            return colunas
        },
        controlesLiberados :function(){
            return this.$route.name == 'projeto-gestao-proponente-detalhamento' && this.projetoEditavel
        },
        ehTelaCooperada :function(){
            return this.$route.name == 'projeto-gestao-proponente-detalhamento'
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao'](this.chavePermissao);
        },
    }
    
}
</script>
<style lang="">
    
</style>